import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=4d70e3b2&scoped=true"
import script from "./firstStep.vue?vue&type=script&lang=js"
export * from "./firstStep.vue?vue&type=script&lang=js"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=4d70e3b2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d70e3b2",
  null
  
)

export default component.exports